import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import { BaseLayout } from 'src/layouts'
import Image from 'next/image'
// Components
import { Header } from './components/Header'
import { ListEntries } from './components/ListEntries'
import { Tags } from './components/Tags'
import { CategorieIcons } from './components/CategorieIcons'
import { SearchBar } from './components/SearchBar'
// States
import { useTags } from 'src/state'
import { useList } from 'src/state'
import { useListContent } from 'src/state'
import { useListIcons } from 'src/state'
import { WEBSITE } from 'src/consts'
import { splitContentByPageBreak } from 'src/utils/content'
import { Container } from 'src/elements'

type ListData = {
  [key: string]: any[]
}

const formatList = data => {
  const itemParse = {}

  if (!!data) {
    data.forEach(item => {
      const obj = item.attributes
      const index = obj.title

      if (!itemParse[index]) {
        itemParse[index] = []
      }

      itemParse[index].push({
        title: obj.title,
        shortPreview: obj.shortPreview,
        content: obj.content,
        slug: obj.slug,
        mainImage: obj.mainImage,
        publishedAt: obj.publishedAt,
        author: obj.author,
        flags: obj.flags,
        mainFlag: obj.mainFlag,
        tags: obj.tags,
        list_index: obj.list_index.data.attributes.image,
        updatedAt: obj.updatedAt,
      })
    })
  }

  return { data: itemParse }
}

export const List = () => {
  const [userInput, setUserInput] = useState('')
  const [activeTags, setActiveTags] = useState([])
  // const [activeCategory, setActiveCategory] = useState(null)
  const [isClickActive, setIsClickActive] = useState(false)
  const listIconsData = useListIcons()
  const formattedListIconsData = listIconsData.data
  const listData: { data: ListData } = formatList(useList().data)
  const keys = Object.keys(listData.data)
  const [dataFilter, setDataFilter] = useState(listData.data)
  const listContent = useListContent()
  const contentSegments = splitContentByPageBreak(listContent.data || '')
  const tagsData = useTags()
  const [tagsArray, setTagsArray] = useState([])
  const [showAllTags, setShowAllTags] = useState(false)

  const handleToggleTags = () => {
    setShowAllTags(prevShowAllTags => !prevShowAllTags)
  }

  const handleClick = selectedLists => {
    const selectedTitles = selectedLists.map(item => item.attributes.title)

    const filteredData = {}

    selectedTitles.forEach(title => {
      if (listData.data[title]) {
        filteredData[title] = listData.data[title]
      }
    })

    setDataFilter(filteredData)

    setIsClickActive(true)
  }

  useEffect(() => {
    if (Array.isArray(tagsData.data)) {
      setTagsArray(tagsData.data)
    } else {
      setTagsArray([])
    }
  }, [tagsData.data])

  const handleTagClick = (clickedTag, isActive) => {
    if (!isActive) {
      const tagExistsInDataFilter =
        dataFilter[clickedTag.attributes.description]

      if (!tagExistsInDataFilter) {
        setActiveTags(prevActiveTags =>
          prevActiveTags.filter(
            tag => tag !== clickedTag.attributes.description
          )
        )
      }
    } else {
      setActiveTags(prevActiveTags => [
        ...prevActiveTags,
        clickedTag.attributes.description,
      ])
    }
  }

  const handleFilter = (searchWord: string) => {
    setUserInput(searchWord)

    const newFilter: { [key: string]: any[] } = {}

    for (const [category, itemList] of Object.entries(listData.data)) {
      const filteredList = itemList.filter((item: { title: string }) => {
        return item.title.toLowerCase().includes(searchWord.toLowerCase())
      })
      if (filteredList.length > 0) {
        newFilter[category] = filteredList
      }
    }

    setDataFilter(newFilter)
  }

  return (
    <div className={styles.listLanding}>
      <div className={styles.mainContent}>
        <Header />
        <CategorieIcons
          listIconsData={formattedListIconsData}
          onCategorySelect={handleClick}
        />
        <SearchBar
          dataObject={dataFilter}
          userInput={userInput}
          onFilter={handleFilter}
        />
        {/* <article className={styles.tagsContainer}>
          {tagsArray.map(tag => (
            <Tags
              key={tag.id}
              tags={tag}
              clickable={true}
              onClick={(clickedTag, isActive) =>
                handleTagClick(clickedTag, isActive)
              }
            />
          ))}
          {tagsArray.length > 5 && (
            <div onClick={handleToggleTags} className={styles.tagsButton}>
              {showAllTags ? (
                <Image
                  src='/assets/icons/icon-arrow-up.svg'
                  alt='Arrow Up'
                  width={16}
                  height={16}
                />
              ) : (
                <Image
                  src='/assets/icons/icon-arrow-down.svg'
                  alt='Arrow Down'
                  width={16}
                  height={16}
                />
              )}
            </div>
          )}
        </article> */}
        <ListEntries data={dataFilter} activeTags={activeTags} />
      </div>
      <Container className={styles.contentContainer}>
        {contentSegments.map((segment, index) => (
          <div
            key={index}
            className={`
              ${index === 0 ? styles.firstContent : styles.otherContent} 
              ${index === contentSegments.length - 1 ? styles.lastContent : ''}
            `}
          >
            <div dangerouslySetInnerHTML={{ __html: segment }} />
          </div>
        ))}
      </Container>
    </div>
  )
}

const ListLayout = ({ children }) => {
  return (
    <BaseLayout
      scrollInContent
      seo={{
        title: 'Digital Leaders | Top 5 Lists | Coin360',
        description:
          'Discover leading digital and crypto services with Coin360s Top 5 Lists. Compare VPNs, wallets, exchanges, and more for savvy online engagement.',
        canonical: `${WEBSITE}/list`,
      }}
    >
      {children}
    </BaseLayout>
  )
}

List.getLayout = ListLayout
